import { all } from '@redux-saga/core/effects';
import legalAcceptanceSaga from 'Core/sagas/legalAcceptanceSaga';
import refreshTokenSaga from 'Core/sagas/refreshTokenSaga';
import schooxSaga from 'Core/sagas/schooxSaga';
import searchSaga from 'Core/sagas/searchSaga';

export default function*() {
  yield all([searchSaga(), legalAcceptanceSaga(), refreshTokenSaga(), schooxSaga()]);
}
